import { render, staticRenderFns } from "./form.vue?vue&type=template&id=fd0dd22c&scoped=true&lang=pug&"
import script from "./form.vue?vue&type=script&lang=ts&"
export * from "./form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0dd22c",
  null
  
)

export default component.exports